module.exports = __webpack_public_path__ + "0b23e110512a40722e4878abe152e53d.png";